export const STATS_DATA_ATTR = 'data-copilot-chat-table-stats'

export interface TableBadgeStats {
  totalColumns: number
  badgedColumns: number
  rejectionReasons: {
    hasLink: number
    mixedValues: number
    noRealValues: number
    noEligibleValues: number
  }
}
